import { render, staticRenderFns } from "./DecorationScore.vue?vue&type=template&id=569bde13&scoped=true"
import script from "./DecorationScore.vue?vue&type=script&lang=js"
export * from "./DecorationScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569bde13",
  null
  
)

export default component.exports